<!-- Begin Page Content -->
<div class="container-fluid">
  <div>
    <!-- <div class="card-header bg-white py-3">
      <div class="row">
        <div class="col-md-6">
          <h1 class="text-gray-800" style="display: inline-block">
            Manage Conductivity Profiles
          </h1>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn custom-buttons-btn"
            style="float: right"
            [routerLink]="[
              '/component',
              'conductivityprofile',
              'add-conductivityprofile'
            ]"
          >
            Add Conductivity Profiles
          </button>
        </div>
      </div>
    </div> -->
    
    
    <!-- Commented on 20th april 2026 for the breadcrumb changes -->
    <!-- <div>
      <div class="col-6">
        <label for="name" class="form-label">Plant:</label>
        <select
          class="form-select border border-dark"
          name="plantid"
          (change)="getSelectedId($event)"
        >
          <option [selected]>Select Plant</option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
        </select>
      </div>

      <div class="col-6">
        <label for="train" class="form-label">Train:</label>
        <select
          class="form-select border border-dark"
          name="trainid"
          (change)="getSelectedTrainId($event)"
        >
          <option [selected]>Select Train</option>
          <option *ngFor="let train of trains" [value]="train.Id">
            {{ train.Name }}
          </option>
        </select>
      </div>
    </div> -->

    <!-- <br />
    <div style="min-height: 20px"></div> -->
    
    <div id="dvRaw">
      <button
        *ngIf="ListConductivityprofiles && ListConductivityprofiles.length > 0"
        class="btn custom-delete-btn m-2"
        (click)="deleteConductivityprofileByTrainId()"
      >
        Delete All Data
      </button>
      <div class="table-responsive" style="max-width: 100vw; overflow: auto;">
        <table
          datatable
          [dtOptions]="dtoptions"
          class="table table-bordered"
          width="100%"
          *ngIf="
            ListConductivityprofiles && ListConductivityprofiles.length > 0
          "
        >
          <thead>
            <tr>
              <th style="width: 10%">Stage</th>
              <th style="width: 10%">Pressure Vessel ID</th>
              <ng-container *ngFor="let date of distinctDates(tableData)">
                <th style="width: 15%">
                  {{ date | date : "yyyy-MM-dd H:mm:ss" }}
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tableData">
              <td style="width: 10%">{{ row.stage }}</td>
              <td style="width: 10%">{{ row.pvId }}</td>
              <td
                *ngFor="let date of distinctDates(tableData)"
                style="width: 15%"
              >
                {{ row[date] | number : "1.2-2" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
     
    </div>
  </div>
</div>
<div style="min-height: 100px"></div>
